// @ts-nocheck

export type TicketGetWithTicketCommentsContactFromAdmin = typeof TicketGetWithTicketCommentsContactFromAdmin[keyof typeof TicketGetWithTicketCommentsContactFromAdmin];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTicketCommentsContactFromAdmin = {
  true: 'true',
  false: 'false',
} as const;
